import { configureStore } from '@reduxjs/toolkit';
import auth from './auth';

const store = configureStore({
  reducer: {
    auth
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: true
    })
});

export const getStore = () => store;
export default store;